import { type BackendMessageStageInput } from '@post-office/message-maker-node/placements/types';

import { buildPlaceOrderHref } from '../../../build-place-order-href';
import { type MessageContextFields } from '../../..';

export type ConfluenceSideNavHydrateResult = {
	entitlementId: string;
	placeOrderHref: string;
	edition: string;
	productName: string;
};

export const hydrate = async ({
	message,
	request,
}: BackendMessageStageInput<MessageContextFields>): Promise<ConfluenceSideNavHydrateResult> => {
	const { entitlementId, transactionAccountId, edition, productName } = message.context;

	const envType = request.executionRuntime.getEnvironmentType();

	const placeOrderHref = buildPlaceOrderHref({
		envType,
		transactionAccountId,
		entitlementId,
		edition,
	});

	return {
		entitlementId,
		placeOrderHref,
		edition,
		productName,
	};
};
